module.exports = ".table{\n    margin: auto;\n    width: 90%;\n}"